module.exports = __webpack_public_path__ + "static/media/certiK logo.293670ed.jpg";